import { readStorage, removeStorage, writeStorage } from '@/utils/storage/base'

const keys = {
  upgradeSuppressDate: 'easyhire_upgrade_suppress_date',
  upgradeDeadlinePopupPrefix: 'easyhire_upgrade_deadline_popup',
  aiScoreDisplayEnabled: 'ai_score_display_enabled',
} as const

const getUpgradeDeadlinePopupKey = (userId: string, campaignId: string) =>
  `${keys.upgradeDeadlinePopupPrefix}:${userId}:${campaignId}`

export const preferenceStorage = {
  getUpgradeSuppressDate: () => readStorage(keys.upgradeSuppressDate, null),
  setUpgradeSuppressDate: (value: string) => writeStorage(keys.upgradeSuppressDate, value),
  clearUpgradeSuppressDate: () => removeStorage(keys.upgradeSuppressDate),
  isUpgradeDeadlinePopupShown: (userId: string, campaignId: string) =>
    readStorage(getUpgradeDeadlinePopupKey(userId, campaignId), '0') === '1',
  setUpgradeDeadlinePopupShown: (userId: string, campaignId: string, shown = true) =>
    shown
      ? writeStorage(getUpgradeDeadlinePopupKey(userId, campaignId), '1')
      : removeStorage(getUpgradeDeadlinePopupKey(userId, campaignId)),

  isAiScoreDisplayEnabled: () => readStorage(keys.aiScoreDisplayEnabled, 'true') !== 'false',
  setAiScoreDisplayEnabled: (enabled: boolean) =>
    writeStorage(keys.aiScoreDisplayEnabled, String(enabled)),
}
